import React from "react";
import { getListingStatusColors } from "src/utils/listings";

const StatusTag = ({ status, date }) => {
  function formatDate(inputDate) {
    const parts = inputDate.split("-");
    const formattedDate = `${parseInt(parts[1], 10)}/${parseInt(
      parts[2],
      10
    )}/${parts[0]}`;
    return formattedDate;
  }

  if (!status) return null;

  const { textColor = "transparent", bgColor = "transparent" } = getListingStatusColors(status);

  return (
    <div
      className="h-[28px] w-fit rounded-[6px] py-[2px] px-2 gap-[6px] pb-2 lg:mb-1"
      style={{ backgroundColor: bgColor }}
    >
      <p
        className="text-[14px] font-semibold leading-6 text-center whitespace-nowrap"
        style={{ color: textColor }}
      >
        {`${status}${date ? ": " : ""} ${date ? formatDate(date) : ""}`}
      </p>
    </div>
  );
};

export default StatusTag;
